import { AccountScreen } from "@/src/screens/account-screen";

export default function AccountRoute() {
  return <AccountScreen />;
}
